import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { useBrand } from '../context/BrandContext'
import { useNavigate } from 'react-router-dom'
import { colors, radius, s, ui } from '../styles/theme'

const API = process.env.REACT_APP_API_URL || 'http://localhost:3000'

const style = {
  input: { ...s.input, padding: '10px 12px' },
  label: { ...s.label, marginBottom: '6px' },
  section: { ...s.card, padding: '20px' },
}

const DEFAULT_CONFIG = {
  is_active: true,
  cargo_enabled: false,
  cargo_limit: 1000,
  cargo_message: 'Ücretsiz kargo için X TL daha ekle!',
  cargo_title: 'Ücretsiz Kargo Fırsatı',
  upsell_enabled: false,
  upsell_price_diff: 30,
  upsell_title: 'Daha İyisini Keşfet',
  crosssell_enabled: false,
  crosssell_title: 'Bunlarla Tamamla',
  opportunity_enabled: false,
  opportunity_product_ids: '',
  opportunity_title: 'Fırsatları Kaçırma',
  carousel_position: 'bottom',
  category_source: 'category',
  campaign_carousels: []
}

const EC_DEFAULT = {
  is_active: false,
  mode: 'bestsellers',
  title: '',
  card_limit: 8,
  manual_product_ids: '',
  fallback_bestsellers: true
}

const EC_MODES = [
  { value: 'ai', label: 'AI (Kişisel)', desc: 'Son gezilen + üyelik sinyalleriyle seçim ve dinamik başlık' },
  { value: 'recently_viewed', label: 'Son Gezilenler', desc: 'Ziyaretçinin son baktığı yazar/kategoriye yakın ürünler' },
  { value: 'bestsellers', label: 'Çok Satanlar', desc: 'En çok yorum alan popüler ürünler' },
  { value: 'campaign', label: 'Kampanyalı Ürünler', desc: 'İndirimi en yüksek ürünler' },
  { value: 'manual', label: 'Manuel Seçim', desc: 'Elle belirlenen ürün ID listesi' }
]

function SmartCart() {
  const { selectedBrand } = useBrand()
  const navigate = useNavigate()
  const [config, setConfig] = useState(DEFAULT_CONFIG)
  const [loading, setLoading] = useState(true)
  const [saving, setSaving] = useState(false)
  const [saved, setSaved] = useState(false)
  const [ec, setEc] = useState(EC_DEFAULT)
  const [ecSaving, setEcSaving] = useState(false)
  const [ecSaved, setEcSaved] = useState(false)

  const token = localStorage.getItem('adminToken')
  const headers = { Authorization: token }

  useEffect(() => {
    if (!selectedBrand) return
    fetchConfig()
    fetchEc()
  }, [selectedBrand?.id]) // eslint-disable-line

  function fetchConfig() {
    setLoading(true)
    axios.get(`${API}/admin/brands/${selectedBrand.id}/smart-cart-config`, { headers })
      .then(res => {
        if (res.data) setConfig({ ...DEFAULT_CONFIG, ...res.data, campaign_carousels: Array.isArray(res.data.campaign_carousels) ? res.data.campaign_carousels : [] })
        setLoading(false)
      })
      .catch(() => setLoading(false))
  }

  function fetchEc() {
    axios.get(`${API}/admin/brands/${selectedBrand.id}/empty-cart-config`, { headers })
      .then(res => { if (res.data) setEc({ ...EC_DEFAULT, ...res.data }) })
      .catch(() => {})
  }

  function set(k, v) { setConfig(c => ({ ...c, [k]: v })) }
  function setE(k, v) { setEc(c => ({ ...c, [k]: v })) }

  function addCarousel() { setConfig(c => ({ ...c, campaign_carousels: [ ...(c.campaign_carousels || []), { enabled: true, min_subtotal: '', title: '', subtitle: '', product_ids: '' } ] })) }
  function removeCarousel(i) { setConfig(c => ({ ...c, campaign_carousels: (c.campaign_carousels || []).filter((_, idx) => idx !== i) })) }
  function updateCarousel(i, k, v) { setConfig(c => ({ ...c, campaign_carousels: (c.campaign_carousels || []).map((x, idx) => idx === i ? { ...x, [k]: v } : x) })) }

  async function handleSaveEc() {
    setEcSaving(true)
    try {
      await axios.post(`${API}/admin/brands/${selectedBrand.id}/empty-cart-config`, ec, { headers })
      setEcSaved(true)
      setTimeout(() => setEcSaved(false), 2500)
    } catch (e) {
      alert('Hata: ' + (e.response?.data?.error || e.message))
    }
    setEcSaving(false)
  }

  async function handleSave() {
    setSaving(true)
    try {
      await axios.post(`${API}/admin/brands/${selectedBrand.id}/smart-cart-config`, config, { headers })
      setSaved(true)
      setTimeout(() => setSaved(false), 2500)
    } catch (e) {
      alert('Hata: ' + (e.response?.data?.error || e.message))
    }
    setSaving(false)
  }

  if (!selectedBrand) return (
    <div style={{ textAlign: 'center', padding: '60px' }}>
      <p style={{ ...ui.notice, display: 'inline-block', marginBottom: '16px' }}>Önce bir marka seçin.</p>
      <button onClick={() => navigate('/brands')} style={s.btnPrimary}>Markalara Git</button>
    </div>
  )

  if (loading) return <p style={ui.emptyText}>Yükleniyor...</p>

  return (
    <div>
      <div className="sx-wrap" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '12px', marginBottom: '24px' }}>
        <h2 style={{ ...s.pageTitle, maxWidth: '100%', overflowWrap: 'anywhere' }}>Smart Cart — {selectedBrand.name}</h2>
        <label style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '14px', cursor: 'pointer' }}>
          <input type="checkbox" checked={config.is_active} onChange={e => set('is_active', e.target.checked)} />
          Aktif
        </label>
      </div>

      {/* 1. Ücretsiz Kargo */}
      <div style={{ ...style.section }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: config.cargo_enabled ? '16px' : 0 }}>
          <div>
            <label style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '15px', fontWeight: 600, cursor: 'pointer' }}>
              <input type="checkbox" checked={config.cargo_enabled} onChange={e => set('cargo_enabled', e.target.checked)} />
              Ücretsiz Kargo Tamamlayıcı
            </label>
            <p style={{ ...s.sectionSubtitle, margin: '4px 0 0 24px' }}>Sepet tutarına göre ücretsiz kargo limitine tamamlayacak ürünler önerir</p>
          </div>
        </div>
        {config.cargo_enabled && (
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginTop: '16px' }}>
            <div>
              <label style={style.label}>Kargo Limiti (TL)</label>
              <input type="number" style={style.input} value={config.cargo_limit} onChange={e => set('cargo_limit', parseInt(e.target.value))} />
            </div>
            <div>
              <label style={style.label}>Carousel Başlığı</label>
              <input style={style.input} value={config.cargo_title} onChange={e => set('cargo_title', e.target.value)} />
            </div>
            <div style={{ gridColumn: '1/-1' }}>
              <label style={style.label}>Mesaj <span style={{ color: colors.textMuted, fontWeight: 400 }}>(X TL = kalan tutar)</span></label>
              <input style={style.input} value={config.cargo_message} onChange={e => set('cargo_message', e.target.value)} />
            </div>
          </div>
        )}
      </div>

      {/* 2. Upsell */}
      <div style={{ ...style.section }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: config.upsell_enabled ? '16px' : 0 }}>
          <div>
            <label style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '15px', fontWeight: 600, cursor: 'pointer' }}>
              <input type="checkbox" checked={config.upsell_enabled} onChange={e => set('upsell_enabled', e.target.checked)} />
              Upsell
            </label>
            <p style={{ ...s.sectionSubtitle, margin: '4px 0 0 24px' }}>Sepetteki ürünlerin daha üst versiyonlarını veya premium alternatiflerini önerir</p>
          </div>
        </div>
        {config.upsell_enabled && (
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginTop: '16px' }}>
            <div>
              <label style={style.label}>Carousel Başlığı</label>
              <input style={style.input} value={config.upsell_title} onChange={e => set('upsell_title', e.target.value)} />
            </div>
            <div>
              <label style={style.label}>Minimum Fiyat Farkı (%)</label>
              <input type="number" style={style.input} value={config.upsell_price_diff} onChange={e => set('upsell_price_diff', parseInt(e.target.value))} />
              <p style={{ fontSize: '11px', color: colors.textMuted, marginTop: '4px' }}>Sepet ürününden en az bu kadar % daha pahalı ürünler önerilir</p>
            </div>
          </div>
        )}
      </div>

      {/* 3. Cross-sell */}
      <div style={{ ...style.section }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: config.crosssell_enabled ? '16px' : 0 }}>
          <div>
            <label style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '15px', fontWeight: 600, cursor: 'pointer' }}>
              <input type="checkbox" checked={config.crosssell_enabled} onChange={e => set('crosssell_enabled', e.target.checked)} />
              Cross-sell
            </label>
            <p style={{ ...s.sectionSubtitle, margin: '4px 0 0 24px' }}>Sepetteki ürünleri tamamlayan farklı kategorilerden ürünler önerir</p>
          </div>
        </div>
        {config.crosssell_enabled && (
          <div style={{ marginTop: '16px' }}>
            <label style={style.label}>Carousel Başlığı</label>
            <input style={style.input} value={config.crosssell_title} onChange={e => set('crosssell_title', e.target.value)} />
          </div>
        )}
      </div>

      <div style={{ ...style.section }}>
        <h4 style={{ ...s.sectionTitle, margin: '0 0 12px' }}>Ürün Eşleştirme Yöntemi</h4>
        <p style={{ ...s.sectionSubtitle, margin: '0 0 12px' }}>AI sepetteki ürünleri hangi kritere göre eşleştirsin?</p>
        <div className="sx-wrap" style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
          {[
            { value: 'category', label: 'Sadece Kategori', desc: 'Mamajoo gibi markalar için' },
            { value: 'brand_category', label: 'Kategori + Yayınevi/Marka', desc: 'Timaş gibi markalar için' }
          ].map(o => (
            <div key={o.value} onClick={() => set('category_source', o.value)}
              style={{ flex: '1 1 220px', minWidth: 0, padding: '12px', borderRadius: radius.md, border: '1px solid ' + (config.category_source === o.value ? colors.primary : colors.border), cursor: 'pointer', background: config.category_source === o.value ? colors.primaryLight : colors.bgCard }}>
              <div style={{ fontWeight: 600, fontSize: '13px', color: colors.textPrimary, marginBottom: '4px' }}>{o.label}</div>
              <div style={{ fontSize: '11px', color: colors.textSecondary }}>{o.desc}</div>
            </div>
          ))}
        </div>
      </div>

      {/* 4. Fırsat Ürünleri */}
      <div style={{ ...style.section }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: config.opportunity_enabled ? '16px' : 0 }}>
          <div>
            <label style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '15px', fontWeight: 600, cursor: 'pointer' }}>
              <input type="checkbox" checked={config.opportunity_enabled} onChange={e => set('opportunity_enabled', e.target.checked)} />
              Fırsat Ürünleri
            </label>
            <p style={{ ...s.sectionSubtitle, margin: '4px 0 0 24px' }}>Manuel olarak belirlenen ürünler her zaman gösterilir, AI kullanılmaz</p>
          </div>
        </div>
        {config.opportunity_enabled && (
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginTop: '16px' }}>
            <div>
              <label style={style.label}>Carousel Başlığı</label>
              <input style={style.input} value={config.opportunity_title} onChange={e => set('opportunity_title', e.target.value)} />
            </div>
            <div>
              <label style={style.label}>Ürün ID Listesi <span style={{ color: colors.textMuted, fontWeight: 400 }}>(virgülle ayırın)</span></label>
              <input style={style.input} value={config.opportunity_product_ids} onChange={e => set('opportunity_product_ids', e.target.value)} placeholder="12345, 12346, 12347" />
            </div>
          </div>
        )}
      </div>

      {/* 5. Campaign Carousel */}
      <div style={{ ...style.section }}>
        <div className="sx-wrap" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: '12px' }}>
          <div style={{ flex: '1 1 260px', minWidth: 0 }}>
            <div style={s.sectionTitle}>Campaign Carousel</div>
            <p style={{ ...s.sectionSubtitle, margin: '4px 0 0' }}>Sepet alt toplamı (kargo hariç) girdiğin minimum fiyatı geçince, manuel eklediğin ürünlerden oluşan carousel görünür. Birden fazla ekleyebilirsin; koşulu sağlayan hepsi aynı anda görünür.</p>
          </div>
          <button onClick={addCarousel} style={{ ...ui.btnSm, whiteSpace: 'nowrap' }}>+ Yeni Ekle</button>
        </div>

        {(config.campaign_carousels || []).length === 0 && (
          <p style={{ ...ui.emptyText, marginTop: '14px' }}>Henüz carousel yok. "Yeni Ekle" ile ilk carouseli oluştur.</p>
        )}

        {(config.campaign_carousels || []).map((cc, i) => (
          <div key={i} style={{ ...s.cardFlat, padding: '16px', marginTop: '14px' }}>
            <div className="sx-wrap" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '10px', marginBottom: '12px' }}>
              <label style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '14px', fontWeight: 600, cursor: 'pointer' }}>
                <input type="checkbox" checked={cc.enabled !== false} onChange={e => updateCarousel(i, 'enabled', e.target.checked)} />
                Carousel #{i + 1}
              </label>
              <button onClick={() => removeCarousel(i)} style={ui.btnDangerQuiet}>Sil</button>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
              <div>
                <label style={style.label}>Minimum Alt Toplam (TL)</label>
                <input type="number" min="0" style={style.input} value={cc.min_subtotal} onChange={e => updateCarousel(i, 'min_subtotal', e.target.value)} placeholder="600" />
                <p style={{ fontSize: '11px', color: colors.textMuted, marginTop: '4px' }}>Sepet alt toplamı bu tutarı geçince görünür</p>
              </div>
              <div>
                <label style={style.label}>Ana Başlık</label>
                <input style={style.input} value={cc.title} onChange={e => updateCarousel(i, 'title', e.target.value)} placeholder="Örn: 600 TL Üzerine Özel Fırsatlar" />
              </div>
              <div style={{ gridColumn: '1/-1' }}>
                <label style={style.label}>Alt Açıklama</label>
                <input style={style.input} value={cc.subtitle} onChange={e => updateCarousel(i, 'subtitle', e.target.value)} placeholder="Örn: Sepetine ekleyebileceğin seçme ürünler" />
              </div>
              <div style={{ gridColumn: '1/-1' }}>
                <label style={style.label}>Ürün ID Listesi <span style={{ color: colors.textMuted, fontWeight: 400 }}>(virgülle ayır, sıralama korunur)</span></label>
                <input style={style.input} value={cc.product_ids} onChange={e => updateCarousel(i, 'product_ids', e.target.value)} placeholder="12345, 12346, 12347" />
              </div>
            </div>
          </div>
        ))}
      </div>

      {saved && <p style={{ ...ui.notice, marginBottom: '12px' }}>✓ Kaydedildi</p>}

      <button onClick={handleSave} disabled={saving} className="sx-full-sm"
        style={{ ...s.btnPrimary, padding: '12px 32px', fontSize: '14px', maxWidth: '100%', opacity: saving ? 0.7 : 1 }}>
        {saving ? 'Kaydediliyor...' : 'Kaydet'}
      </button>

      {/* ===== BOŞ SEPET (Empty Cart) ===== */}
      <div style={{ ...s.divider, margin: '40px 0 24px' }} />
      <div className="sx-wrap" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '12px', marginBottom: '16px' }}>
        <div style={{ flex: '1 1 240px', minWidth: 0 }}>
          <h2 style={s.pageTitle}>Boş Sepet Carousel</h2>
          <p style={{ ...s.pageSubtitle, margin: '4px 0 0' }}>Sepet boşken gösterilecek öneri carousel'i</p>
        </div>
        <label style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '14px', cursor: 'pointer' }}>
          <input type="checkbox" checked={ec.is_active} onChange={e => setE('is_active', e.target.checked)} />
          Aktif
        </label>
      </div>

      <div style={{ ...style.section }}>
        <label style={style.label}>Carousel Kaynağı (Mod)</label>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))', gap: '10px', marginBottom: '16px' }}>
          {EC_MODES.map(o => (
            <div key={o.value} onClick={() => setE('mode', o.value)}
              style={{ padding: '12px', borderRadius: radius.md, border: '1px solid ' + (ec.mode === o.value ? colors.primary : colors.border), cursor: 'pointer', background: ec.mode === o.value ? colors.primaryLight : colors.bgCard }}>
              <div style={{ fontWeight: 600, fontSize: '13px', color: colors.textPrimary, marginBottom: '4px' }}>{o.label}</div>
              <div style={{ fontSize: '11px', color: colors.textSecondary }}>{o.desc}</div>
            </div>
          ))}
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
          <div>
            <label style={style.label}>Carousel Başlığı {ec.mode === 'ai' && <span style={{ color: colors.textMuted, fontWeight: 400 }}>(boşsa AI üretir)</span>}</label>
            <input style={style.input} value={ec.title} onChange={e => setE('title', e.target.value)} placeholder="Örn: Sizin İçin Seçtiklerimiz" />
          </div>
          <div>
            <label style={style.label}>Ürün Sayısı</label>
            <input type="number" min="1" max="20" style={style.input} value={ec.card_limit} onChange={e => setE('card_limit', parseInt(e.target.value) || 8)} />
          </div>
          {ec.mode === 'manual' && (
            <div style={{ gridColumn: '1/-1' }}>
              <label style={style.label}>Ürün ID Listesi <span style={{ color: colors.textMuted, fontWeight: 400 }}>(virgülle ayırın)</span></label>
              <input style={style.input} value={ec.manual_product_ids} onChange={e => setE('manual_product_ids', e.target.value)} placeholder="12345, 12346, 12347" />
            </div>
          )}
        </div>

        {ec.mode !== 'manual' && ec.mode !== 'bestsellers' && (
          <label style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '13px', cursor: 'pointer', marginTop: '16px' }}>
            <input type="checkbox" checked={ec.fallback_bestsellers} onChange={e => setE('fallback_bestsellers', e.target.checked)} />
            Yeterli ürün bulunamazsa çok satanlarla tamamla
          </label>
        )}
      </div>

      {ecSaved && <p style={{ ...ui.notice, marginBottom: '12px' }}>✓ Boş Sepet ayarları kaydedildi</p>}
      <button onClick={handleSaveEc} disabled={ecSaving} className="sx-full-sm"
        style={{ ...s.btnSecondary, padding: '12px 32px', fontSize: '14px', fontWeight: '600', maxWidth: '100%', opacity: ecSaving ? 0.7 : 1 }}>
        {ecSaving ? 'Kaydediliyor...' : 'Boş Sepet Ayarlarını Kaydet'}
      </button>
    </div>
  )
}

export default SmartCart